import React from 'react';
import PermissionsTable from './PermissionsTable';

export default function PermissionsPage() {
  return (
    <div className="eduss-page-wrapper">
      <PermissionsTable />
    </div>
  );
}